module.exports = __webpack_public_path__ + "media/7.aec918ff.wav";